<template>
    <div id="inviteList">
        <my-header></my-header>
        <div class="main-container mainCon">
            <el-form class="invite-form" label-width="140px" ref="form" :model="form">
                <el-row>
                    <el-form-item label="招标公告：" >
                        <el-input size="medium" v-model="form.msgTitle" clearable style="width: 360px;margin-right: 20px"></el-input>
                        <el-button class="btn-theme" size="medium"  icon="el-icon-search" @click="searchMethod">搜索</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <ul class="listContent" v-if="inviteListData && inviteListData.length">
                <li v-for="(item,index) in inviteListData" :key="index">
                   <div class="leftIndex">
                       <img :src='"../../assets/images/inviteList/0"+(index+1)+".png"' />
                   </div>
                    <div class="rightText">
                        <h3>
                            <el-tooltip :content="item.announcementName" :disabled="item.announcementName && item.announcementName.length<30" effect="light">
                                <strong @click="toDetail(item)">{{ item.announcementName }}</strong>
                            </el-tooltip>
                            <span>发布日期：{{ item.createDate }}</span>
                        </h3>
                        <p>招标类别：<span>{{ item.categoryName || '无' }}</span></p>
                    </div>
                </li>
            </ul>
            <p v-else class="noResults">没有搜索结果</p>
         <!--   prev-text="上一页"
            next-text="下一页"-->
            <el-pagination
                :page-size="pager.pageSize"
                @current-change="handleCurrentChange"
                :current-page="pager.pageNum"
                :total="pager.total"
                layout="total, prev, pager, next"
                background
            >
            </el-pagination>
        </div>
        <!-- <my-footer></my-footer> -->
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../common/Header.vue'
    import MyFooter from '../common/Footer.vue'
    export default {
        name: 'invite-list',
        data(){
            return {
                form: {
                    categoryId: '',
                    msgTitle: '',
                },
                inviteListData: [],//招标公告列表数据；
                pager:{
                    total: 0,
                    pageNum: 1,
                    pageSize: 8
                },
                types:[],//招标类别下拉选项
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            this.$root.activeIndex = 'invite';
            this.getCurrentList(1);//获取初始化第一页数据；
//             var _this = this;
//             _this.$root.postHttp('v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{//获取招标类别
//                 "pageNumber": 1,
//                 "pageSize": 0
//             },function(res){
// //               console.log('分类',res)
//                 _this.types = res.data.data.tree;
//             });
        },
        methods:{
            getCurrentList(type){
                let _this = this;
                let obj = {};
                if(type == 1){
                    obj = {
                        "pageFlag": 1,//1分页，0不分页
                        "pageNumber": _this.pager.pageNum,
                        "pageSize": _this.pager.pageSize,
                    };
                } else if(type == 2) {
                    obj = {
                        "announcementName": this.form.msgTitle,
                        "announcementStatus": 2,
                        "pageFlag": 1,//1分页，0不分页
                        "pageNumber": _this.pager.pageNum,
                        "pageSize": _this.pager.pageSize,
                    };
                }
                this.$root.postHttp('/v1/sAnnouncement/public/searchList',obj,function (res) {
                    _this.pager.total = res.data.data.count;
                    _this.inviteListData = res.data.data.list || [];
                    console.log('列表',_this.inviteListData)
                })
            },
            toDetail(val){//到详情页。
//              console.log(id)
                this.$router.push('/invite-listDetail/'+val.id+'/'+val.acType);
            },
            handleCurrentChange (page) {//当前页
                this.pager.pageNum = page;
                this.getCurrentList(1);//获取当前页列表数据；
            },
            searchMethod(){//搜索列表
                this.getCurrentList(2);
            }
        }
    }
</script>
<style lang="scss">
    @import '../../assets/_var.scss';
    #inviteList {
        & .head-top{
            background: #fff;
        }
        & .head-right {
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                // background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .mainCon {
            margin-top: 50px;
            margin-bottom: 165px;
        }
        .location {
            padding-left: 15px;
            text-align: left;
            font-size: 12px;
            line-height: 42px;
            color: $--text-color-light;
            background: url('../../assets/images/inviteList/location.png') no-repeat left center;
        }
        .invite-form {
            background: $--primary-fill-color;
            margin-top: 30px;
            .el-row {
                padding: 30px 0;
            }
            .el-form-item {
                margin: 0;
            }
            .btn-theme {
                background: $--primary-color;
                color: white;
            }
            .el-button:hover, .el-button:focus {
                //background: #fae7eb;
            }
        }
        .listContent {
            li {
                overflow: hidden;
                padding: 20px 0;
                border-bottom: 1px solid $--secondary-fill-color;
                .leftIndex {
                    float: left;
                    background-color: $--secondary-fill-color;
                    line-height: 80px;
                    text-align: center;
                    width: 80px;
                    color: $--primary-color;
                    img {
                        vertical-align: middle;
                    }
                }
                .rightText {
                    float: left;
                    width: 1090px;
                    margin-left: 30px;
                    h3 {
                        overflow: hidden;
                        line-height: 40px;
                        strong {
                            float: left;
                            max-width: 500px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 16px;
                            color: $--text-color;
                            cursor: pointer;
                        }
                        strong:hover {
                            color: $--primary-color;
                            text-decoration: underline;
                        }
                        span {
                            float: right;
                            font-size: 14px;
                            font-weight: normal;
                            color: $--text-color-lighter;
                        }
                    }
                    p {
                        padding-left: 22px;
                        text-align: left;
                        color: $--text-color-lighter;
                        font-size: 14px;
                        line-height: 50px;
                        background: url('../../assets/images/inviteList/icon01.png') no-repeat left center;
                        span {
                            color: $--text-color-light;
                        }
                    }
                }
            }
        }
        .noResults {
            font-size: 16px;
            color: #999;
            margin: 50px;
        }
        .el-pagination {
            margin: 50px 0 70px;
            text-align: right;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/invite/List.vue